import { notify } from '@ps-int/ps-components/src/notifications/slice';
import type { CloudAPI } from '@yandex-360/telemost-sdk/cloud-api';
import { ARTIFACT } from '@yandex-360/telemost-sdk/cloud-api';
import { call, put, select } from 'typed-redux-saga';

import { NOTIFICATIONS_MAP } from '../../../shared/features/notifications/ps-notifications';
import { cloudApi } from '../../../shared/helpers/transport';
import { NotificationId } from '../../call/types';
import { ARTIFACTS_FILTER_OPTION } from '../constants';
import { setFetchingStatus } from '../features/fetching/slice';
import { addItems } from '../features/history-items/slice';
import { selectFilterArtifacts, selectFilterFromTo, selectIterationKey } from '../selectors';
import { FETCHING_STATUS } from '../types';

export function* fetchBatchSaga() {
    yield* put(setFetchingStatus(FETCHING_STATUS.IN_PROGRESS));
    const artifacts = yield* select(selectFilterArtifacts);
    const fromTo = yield* select(selectFilterFromTo);
    const payload: CloudAPI.ConferencesHistory.Request = {};
    if (fromTo.from) {
        payload.from = new Date(`${fromTo.from}T00:00:00`).toISOString();
    }
    if (fromTo.to) {
        const toDate = new Date(`${fromTo.to}T00:00:00`);
        toDate.setDate(toDate.getDate() + 1);
        payload.to = toDate.toISOString();
    }
    if (artifacts !== ARTIFACTS_FILTER_OPTION.ALL_CONFS) {
        payload.artifact = {
            [ARTIFACTS_FILTER_OPTION.NO_ARTIFACTS]: ARTIFACT.WITHOUT_ARTIFACTS,
            [ARTIFACTS_FILTER_OPTION.WITH_RECORDING]: ARTIFACT.RECORDING,
            [ARTIFACTS_FILTER_OPTION.WITH_REPORT]: ARTIFACT.MEETING_REPORT,
            [ARTIFACTS_FILTER_OPTION.WITH_SUMMARY]: ARTIFACT.SUMMARIZATION,
        }[artifacts];
    }
    const iterationKey = yield* select(selectIterationKey);
    try {
        const response = yield* call([cloudApi, cloudApi.getConferencesHistoryBatch], payload, iterationKey);
        yield* put(
            addItems({
                iterationKey: response.iteration_key,
                items: response.items.map((item) => ({
                    sessionId: item.session_id,
                    shortUrlId: item.short_url_id,
                    meetingName: item.meeting_name,
                    startedAt: item.started_at,
                    endedAt: item.ended_at,
                    summarizationStatus: item.summarization_status,
                    cloudRecordingStatus: item.cloud_recording_status,
                    hasMeetingReport: item.has_meeting_report,
                    hasLocalRecording: item.has_local_recording,
                })),
            })
        );
    } catch (error) {
        yield* put(setFetchingStatus(FETCHING_STATUS.ERROR));
        yield* put(notify(NOTIFICATIONS_MAP[NotificationId.CONF_HISTORY_FETCHING_FAILED]()));
        return;
    }
    yield* put(setFetchingStatus(null));
}
